import { memo } from 'react';
const compose = (providers) =>
  providers.reduce((Prev, Curr) => ({ children }) => (
    <Prev>
      <Curr>{children}</Curr>
    </Prev>
  ));

export const composeStable = (providers) => {
  const Wrapped = providers.reduce(
    (Prev, Curr) => {
      const Wrap = ({ children }) => (
        <Prev>
          <Curr>{children}</Curr>
        </Prev>
      );
      return memo(Wrap);
    },
    ({ children }) => <>{children}</> // base
  );
  return memo(Wrapped);
};

export default compose;
